import { render, staticRenderFns } from "./ModalPreviewDataImport.vue?vue&type=template&id=a2489cd2"
import script from "./ModalPreviewDataImport.vue?vue&type=script&lang=js"
export * from "./ModalPreviewDataImport.vue?vue&type=script&lang=js"
import style0 from "./ModalPreviewDataImport.vue?vue&type=style&index=0&id=a2489cd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports